export default {"src":"/_next/static/media/ArcBottomRightWhite.120a4536.svg","height":20,"width":14,"blurWidth":0,"blurHeight":0};